import React from "react";
import { PageContentWrapper, PageHeader, PageFooter } from "./partial";
import { useCustomThemeContext } from "components/mui-providers";
import { injectIntl } from "react-intl";

const Page = ({ children, classes, intl }) => {
  const {
    customTheme: { footerData, headerData },
  } = useCustomThemeContext();

  return (
    <>
      <PageHeader url={headerData.logo.link} logoUrl={headerData.logo.src} logoAlt={headerData.logo.alt} />
      <PageContentWrapper>{children}</PageContentWrapper>
      <PageFooter url={footerData.logo.link} logoUrl={footerData.logo.src} logoAlt={footerData.logo.alt} />
    </>
  );
};

export default injectIntl(Page);
